
import { pluralize } from "@utils";
import ClickOutside from "vue-click-outside";
export default {
	directives: {
		ClickOutside,
	},
	inject: ["searchParams"],
	data() {
		return {
			isHintVisible: false,
		};
	},
	computed: {
		hint() {
			const wildcardsLength =
				this.$store.getters["query/alternativeWildcardsCount"];
			const word = pluralize(wildcardsLength, "wildcard");
			return `Showing words with ${(
				this.searchParams?.tiles || ""
			).toUpperCase()} and ${wildcardsLength === 1 ? "a" : ""} ${word}`;
		},
		firstTimeAccess() {
			return this.$store.state.navigation.firstTimeAccess;
		},
	},
	methods: {
		openHintDetails() {
			this.isHintVisible = !this.isHintVisible;
		},
		closeHintDetails(event) {
			if (event.composedPath().includes(this.$refs?.hintButton)) {
				return false;
			}

			this.isHintVisible = false;
		},
	},
};
